import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./step2Travel.css";
import "./step5Travel.css";

const steps = ["Traveler & Budget", "Schedule", "Cash Advance", "Documents", "Review & Submit"];

const Stepper = () => (
  <div className="s2-stepper">
    {steps.map((label, index) => (
      <React.Fragment key={label}>
        <div className={`s2-step ${index < 4 ? "done" : "active"}`}>
          <span>{index < 4 ? <i className="ri-check-line" /> : index + 1}</span>
          <div><strong>{label}</strong><small>{index < 4 ? "Completed" : "In progress"}</small></div>
        </div>
        {index < 4 && <i className="s2-step-line done" />}
      </React.Fragment>
    ))}
  </div>
);

const Info = ({ label, children, wide = false }) => (
  <div className={`s5-info ${wide ? "wide" : ""}`}><small>{label}</small><strong>{children}</strong></div>
);

const ReviewCard = ({ number, title, editTo, children }) => (
  <section className="s5-card">
    <header className="s5-card-title"><h2><span>{number}</span>{title}</h2><Link to={editTo}>Edit</Link></header>
    <div className="s5-card-body">{children}</div>
  </section>
);

const TravelRequestCreateStep5 = () => {
  const [confirmed, setConfirmed] = useState(true);
  const [submitted, setSubmitted] = useState(false);

  return <div className="s2-page s5-page">
    <div className="s2-heading"><div><h1>Create Travel Request</h1><p>Step 5 of 5 · Review & Submit</p></div><Stepper /></div>
    <div className="s2-layout">
      <main className="s5-main">
        <ReviewCard number="1" title="Traveler & Trip Information" editTo="/travel/create/step-1">
          <div className="s5-info-grid">
            <Info label="Name">Eldren Aniell Dunggat</Info><Info label="Title">Manager</Info><Info label="Departure">25 August 2026</Info>
            <Info label="Return">30 August 2026</Info><Info label="Duration">6 Days / 5 Nights</Info><Info label="Destination">Singapore</Info>
            <Info label="Purpose" wide>Attend the regional business events and investment meetings.</Info>
          </div>
        </ReviewCard>

        <ReviewCard number="2" title="Travel Schedule & Accommodation" editTo="/travel/create/step-2">
          <table className="s5-schedule"><thead><tr><th>Date</th><th>Activity</th></tr></thead><tbody>
            <tr><td>25/08/2026</td><td>Depart Kuching, Sarawak → Arrive Singapore</td></tr>
            <tr><td>26–28/08/2026</td><td>Regional business events and investment meetings</td></tr>
            <tr><td>29/08/2026</td><td>Depart Singapore for final leg</td></tr>
            <tr><td>30/08/2026</td><td>Arrive Kuching, Sarawak (final destination)</td></tr>
          </tbody></table>
          <div className="s5-table-wrap"><table className="s5-data-table"><thead><tr><th>Destination</th><th>Arrival</th><th>Departure</th><th>Transport</th><th>Hotel</th></tr></thead><tbody>
            <tr><td>Singapore</td><td>25/08/2026</td><td>29/08/2026</td><td>Air</td><td>Marina Bay · 4 nights · 1 person · No breakfast</td></tr>
            <tr><td>Kuching, Sarawak <em>Final</em></td><td>30/08/2026</td><td>—</td><td>Air</td><td>Return home — no hotel</td></tr>
          </tbody></table></div>
        </ReviewCard>

        <ReviewCard number="3" title="Cash Advance" editTo="/travel/create/step-3">
          <div className="s5-info-grid">
            <Info label="Travel Type">International</Info><Info label="Previous Claim Submitted">Yes</Info><Info label="Corporate Credit Card">No</Info>
            <Info label="Requesting Cash Advance">Yes</Info><Info label="Requested Amount">RM 870.00</Info><Info label="Unusual Circumstances">Yes</Info>
            <Info label="Reason" wide>Transportation and meals during the regional business trip.</Info>
          </div>
        </ReviewCard>

        <ReviewCard number="4" title="Required Documents" editTo="/travel/create/step-4">
          <div className="s5-documents">
            <div><span><i className="ri-file-text-line" /> Event Invitation / Agenda</span><b><i className="ri-checkbox-circle-fill" /> Uploaded</b></div>
            <div><span><i className="ri-file-text-line" /> Travel Itinerary</span><b><i className="ri-checkbox-circle-fill" /> Uploaded</b></div>
          </div>
        </ReviewCard>

        <label className="s5-confirm"><input type="checkbox" checked={confirmed} onChange={(event) => setConfirmed(event.target.checked)} /><span>I confirm that the information provided is accurate and complies with the company travel policy.</span></label>
      </main>

      <aside className="s5-aside">
        <section><h3><i className="ri-list-check-2" /> Trip Summary</h3><dl><dt>Request Type</dt><dd>International Travel</dd><dt>Destination</dt><dd>Singapore</dd><dt>Duration</dt><dd>6 Days / 5 Nights</dd><dt>Budget Code(s)</dt><dd>BE-OPS-001</dd><dt>Cash Advance</dt><dd>RM 870.00</dd></dl><div className="s5-ready"><i className="ri-checkbox-circle-fill" /> Ready to Submit</div></section>
        <section><h3><i className="ri-route-line" /> Approval Route</h3><ol><li><span>1</span><div><strong>Head of Unit</strong><small>Reviews trip details</small></div></li><li><span>2</span><div><strong>Head of Department</strong><small>Department approval</small></div></li><li><span>3</span><div><strong>Admin</strong><small>Bookings and actual costs</small></div></li><li><span>4</span><div><strong>Finance</strong><small>Cash advance processing</small></div></li></ol></section>
        <section className="s5-note"><h3><i className="ri-lightbulb-line" /> Next Step</h3><p>After submission, the request follows the approval route. Admin and Finance proceed only after the required approvals are completed.</p></section>
      </aside>
    </div>

    <footer className="s2-actions"><Link to="/travel/create/step-4">Back</Link><span>Step 5 of 5 · Review & Submit</span><div><button type="button">Save as Draft</button><button type="button" className="primary" disabled={!confirmed} onClick={() => setSubmitted(true)}>Submit Request</button></div></footer>

    {submitted && <div className="s5-modal" role="dialog" aria-modal="true"><div><i className="ri-check-line" /><h2>Request Submitted</h2><p>Your travel request has been submitted for approval.</p><Link to="/travel">Return to Travel Requests</Link></div></div>}
  </div>;
};

export default TravelRequestCreateStep5;
